// AUTO-GENERATED by scripts/genVersion.cjs — do not edit.
export const BUILD_ID = "2026-11-02T23-41-42-785Z";
export const GIT_SHA = "960d61b";
